import uirouter from '@uirouter/angularjs';
import common from 'app/modules/common';

export default angular
  .module('app.holding.dashboard.metals', [
    uirouter,
    common,
  ])
  .name;

require('./constants/troy-rate');
require('./directives/buy-vault-selector/buy-vault-selector');
require('./directives/metal-badge/metal-badge');
require('./directives/metal-toggle/metal-toggle');
require('./directives/metals-balance/metals-balance');
require('./directives/metals-more-menu/metals-more-menu');
require('./directives/sell-result-data/sell-result-data');
require('./directives/sell-vault-selector/sell-vault-selector');
require('./directives/statement-metals/statement-metals');
require('./filters/convert-grams-to-ounces');
require('./filters/convert-ounces-to-grams');
require('./services/metals');
require('./states/metals');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/metals/index.js